import { api } from './../../api.js';
import { config } from './../../config.js';

const state = {
    front_events: null,
    teatro: null,
    footer: null,
    legal: null,
    privacidad: null,
    patrocinadores: [],
    recinto: null,
    iva_sports: 21,
    iva_teatros: 10,
    lista_abonados: null,
    front_experiencias: null,
}

const getters = {
    getFrontEvents : state => {
        return state.front_events;
    },
    getFooter : state => {
        return state.footer;
    },
    getTeatro : state => {
        return state.teatro;
    },
    getIva: state => {
        if (state.footer.tipo == 1){
            return state.iva_sports

        } else if (state.footer.tipo == 2){
            return state.iva_teatros
        }
    },
    getLegal : state => {
        return state.legal;
    },
    getPrivacidad : state => {
        return state.privacidad;
    },
    getPatrocinadores : state => {
        return state.patrocinadores;
    },
    getRecinto : state => {
        return state.recinto;
    },
    getListaAbonados: state => {
        return state.lista_abonados;
    },
    getFrontExperiencias : state => {
        return state.front_experiencias;
    },
}

const mutations = {
    setFrontEvents : (state, events) => {
        state.front_events = events;
    },
    setTeatro : (state, teatro) => {
        state.teatro = teatro;
    },
    setFooter : (state, footer) => {
        state.footer = footer;
    },
    setLegal : (state, legal) => {
        state.legal = legal;
    },
    setPrivacidad : (state, privacidad) => {
        state.privacidad = privacidad;
    },
    setPatrocinadores : (state, patrocinadores) => {
        state.patrocinadores = patrocinadores;
    },
    setRecinto : (state, recinto) => {
        state.recinto = recinto;
    },
    setListaAbonados : (state, lista) => {
        state.lista_abonados = lista;
    },
    setFrontExperiencias : (state, experiencias) => {
        state.front_experiencias = experiencias;
    },
    UPDATE_EVENT_DISPONIBILIDAD : (state, { evento_id }) => {
        const evento = state.front_events.data.find(e => e.id === evento_id);
        const experiencia = state.front_experiencias.data.find(ex => ex.id === evento_id)

        evento && (evento.libres = 0, evento.sesiones_activas = true, evento.libres_abonados = true);

        experiencia && (experiencia.libres = 0, experiencia.sesiones_activas = true);
    }
}

const actions = {
    SETTINGS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('settings'), data).then(res => {
                resolve(res);
                commit('setFooter', res.data.manager);
                commit('setTeatro', res.data.teatro);
                commit('setRecinto', res.data.recinto);
                commit('setLegal', res.data.manager);
                commit('setPrivacidad', res.data.manager.privacidad);
                commit('setPatrocinadores', res.data.patrocinadores);
                commit('setListaAbonados', res.data.lista_abonados);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_EVENTS_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.events.index'), data).then(res => {
                resolve(res);
                commit('setFrontEvents', res.data);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_EXPERIENCIAS_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.experiencias.index'), data).then(res => {
                resolve(res);
                commit('setFrontExperiencias', res.data);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_EVENTS_SHOW_SESIONES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.events.show-sesiones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_EVENTS_SHOW : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.events.show'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_LIBERAR_ASIENTOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.abono.liberar-asientos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_ABONO_LIBERAR_ASIENTOS_EVENTS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.abono.liberar-asientos.events'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_ABONO_LIBERAR_ASIENTOS_EVENT_SESSION : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.abono.liberar-asientos.event.session'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_PLAZOS_ABONO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.abono.plazos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_PLAZOS_BASE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.base.plazos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PROCESAR_COMPRA_PRECIO_CERO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.events.procesar-compra-precio-cero'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_EVENTS_SESION_ZONAS_ANEXAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.events.sesion.zonas.anexas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_EVENTS_SESION_ZONA_ANEXA_BUTACAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.events.sesion.zona.anexa.butacas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_EVENTS_SESION_PRODUCTOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.events.sesion.productos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_EVENTO_SESION_SECCIONES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.evento.sesion.secciones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_EVENTO_SESION_SECCIONES_SVG : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.evento.sesion.secciones.svg'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_EVENTO_SESION_SECCIONES_SECCION_SVG : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.evento.sesion.secciones.seccion.svg'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_EVENTO_SESION_SECCIONES_SECCION_REGIONES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.evento.sesion.secciones.seccion.regiones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_EVENTS_SELECT: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.events.select'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_EVENTS_REGIONES_SIN_ASIENTOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.evento.regiones.sin-asientos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_EVENTS_REGISTRAR_PREVENTA : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.events.registrar-preventa'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    }
}

export default {
    state,
    actions,
    getters,
    mutations
};
